// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3wbhu","container":"styles_container__aRG4b","title":"styles_title__2a-Ab","wrapper":"styles_wrapper__3Kgy3","answer":"styles_answer__27Lp9"};